import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  Create,
  Edit,
  SimpleForm,
  TextInput,
  EditButton,
  DeleteButton,
  TopToolbar,
  CreateButton,
  ExportButton,
} from 'react-admin';

const ServiceTemplateListActions = () => (
  <TopToolbar>
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

export const ServiceTemplateList = () => (
  <List actions={<ServiceTemplateListActions />}>
    <Datagrid rowClick={false}>
      <TextField source="name" />
      <TextField source="category" />
      <TextField source="description" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
);

export const ServiceTemplateCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="name" required />
      <TextInput source="category" required />
      <TextInput source="description" multiline minRows={3} />
    </SimpleForm>
  </Create>
);

export const ServiceTemplateEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="name" disabled />
      <TextInput source="category" required />
      <TextInput source="description" multiline minRows={3} />
    </SimpleForm>
  </Edit>
);
